<div class="rush-main">
  <app-logger-tabs class="content"></app-logger-tabs>
</div>
